// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card {\n    background: var(--cardBackgroundColor);\n    border-radius: 8px;\n    box-shadow: 0px 0px 11px 3px var(--boxShadow);\n    box-sizing: border-box;\n    transition-duration: 100ms;\n    transition-property: box-shadow, margin;\n}\n\n.card.animate-press:active {\n    box-shadow: 0px 0px 4px 1px var(--boxShadowLight);\n}\n\n.card.collapsed {\n    background: transparent;\n    box-shadow: 0 0 0 0 transparent;\n}\n.card.advanced_chart {\n    box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
